/**
 * When the visit happened, as the inspector entered it (JIM-0919-04).
 *
 * The date box defaults to today and the time box to the moment the
 * inspection was opened; both stay editable so a back-dated visit carries a
 * real time (Jim 2026-09-19: "it already has today's date, it already has the
 * time… if you want to modify it, you can… if you enter, it'll use what's
 * entered"). The pair is read in the device's zone and sent as UTC. The
 * report footer prints it back; the admin side keeps the row's created_at as
 * the real entry time.
 */
export function conductedAtIso(
  date: string,
  time: string,
  now: Date = new Date()
): string {
  const day = /^\d{4}-\d{2}-\d{2}$/.test(date)
    ? date
    : now.toLocaleDateString('en-CA');
  const clock = /^\d{2}:\d{2}(:\d{2})?$/.test(time)
    ? time.slice(0, 5)
    : localClock(now);
  // No zone suffix → parsed as local time, which is what the inspector meant.
  const local = new Date(`${day}T${clock}:00`);
  return Number.isNaN(local.getTime())
    ? now.toISOString()
    : local.toISOString();
}

/** HH:MM in the device's zone — the time box's default. */
export function localClock(now: Date = new Date()): string {
  const h = String(now.getHours()).padStart(2, '0');
  const m = String(now.getMinutes()).padStart(2, '0');
  return `${h}:${m}`;
}
